export const UPDATE_NO_RESULTS_MESSAGE = 'UPDATE_NO_RESULTS_MESSAGE';

type NoResultsMessage = string;

export const updateNoResultsMessage = (payload: NoResultsMessage) => ({
    type: UPDATE_NO_RESULTS_MESSAGE,
    payload,
});

export default (state = '', action: { type: string; payload: NoResultsMessage }) =>
    action.type === UPDATE_NO_RESULTS_MESSAGE ? action.payload : state;
